import { applicationContext, foundationContext } from '@philips-internal/oswald-ui-foundation';
import { DataContext } from '@philips-internal/oswald-ui-core/lib/component/context';
import { setupAuthentication } from './authentication';
import { setupModules } from './modules';
import { setupLocalization } from './localization';
import Audit from './audit';
import { setupTheme } from './theme';
import {setupFileService} from './file-service';
import { setupTwsUserParameters } from './tws-user-parameters';
import { ApplicationContextListenerScope } from '@philips-internal/oswald-ui-constants';
import { APPLICATION_ROUTES } from '../constants/application-routes';
import { isMobile } from '@philips-internal/oswald-ui-utils';
import { HistoryService } from '@philips-internal/oswald-ui-core/lib/services';

const FOUNDATION_DATA_CONTEXT = new DataContext();

function getFoundationDataContext(): DataContext {
  return FOUNDATION_DATA_CONTEXT;
}

function clearNavigationStackForDesktop(): void {
  applicationContext.addListener(ApplicationContextListenerScope.MODULES, () => {
    const currentModuleRoute = applicationContext.getCurrentModule()?.route;
    const routesToClearNavigationStack = [
      APPLICATION_ROUTES.HOME_DASHBOARD,
      APPLICATION_ROUTES.PSEUDONYM_APPOINTMENTS,
      APPLICATION_ROUTES.EXAMS,
      APPLICATION_ROUTES.TASKS,
    ];

    routesToClearNavigationStack.forEach(route => {
      if (currentModuleRoute === route) {
        applicationContext.clearNavigationStack();
      }
    })
  });
}

function popNavigationItemOnDesktopBrowserBack() :void {
  window.addEventListener('popstate', () => {
    const NavigationStackSize = applicationContext.getNavigationStackSize();
    NavigationStackSize > 0 && applicationContext.popNavigationItem();
  })
}

function bootstrap(): Promise<void> {

  foundationContext.setCanEditSector(false);
  foundationContext.setCanEditProfile(false);
  foundationContext.setCanEditEstablishment(false);

  setupAuthentication();
  setupModules();
  setupLocalization();
  setupFileService();

  if (!isMobile()) {
    clearNavigationStackForDesktop();
    popNavigationItemOnDesktopBrowserBack();
  }

  const audit = new Audit();
  audit.routeChangeLog(HistoryService.getCurrentRoute());

  return Promise.all(
    [
      setupTheme().then(theme =>
        FOUNDATION_DATA_CONTEXT.set({ loginContentTonalRange: theme.dsCorLogin })
      ),
      setupLocalization(),
      setupTwsUserParameters(),
    ])
    .then(() => Promise.resolve());

}

export { bootstrap as default, getFoundationDataContext };
